export const FIELD_TYPE_OPTIONS = [
  { value: 'account_email', label: 'Email tài khoản' },
  { value: 'email', label: 'Email' },
  { value: 'text', label: 'Văn bản' },
  { value: 'date', label: 'Ngày tháng' },
  { value: 'phone', label: 'Số điện thoại' },
  { value: 'citizen_id', label: 'Số CCCD' },
  { value: 'radio', label: 'Lựa chọn (radio)' },
  { value: 'exam_date', label: 'Chọn ngày thi (từ danh sách ngày thi)' },
  { value: 'school', label: 'Trường THPT (Tỉnh + Xã + Tên trường)' },
];

export const FIELD_TYPE_PRESETS = {
  account_email: {
    type: 'email',
    name: 'account_email',
    label: 'Email tài khoản',
    placeholder: 'Email tài khoản',
    required: true,
    readonly_when_logged_in: true,
  },
  email: {
    type: 'email',
    name: 'student_email',
    label: 'Email',
    placeholder: 'Email',
    required: true,
  },
  text: {
    type: 'text',
    name: 'custom_field',
    label: 'Trường văn bản',
    placeholder: '',
    required: false,
  },
  date: {
    type: 'date',
    name: 'birth_date',
    label: 'Ngày sinh',
    placeholder: 'Chọn ngày',
    required: true,
  },
  phone: {
    type: 'phone',
    name: 'phone',
    label: 'Số điện thoại',
    placeholder: 'Số điện thoại',
    required: true,
    pattern: '^(0|\\+84)\\d{9,10}$',
    pattern_message: 'Số điện thoại không hợp lệ',
  },
  citizen_id: {
    type: 'citizen_id',
    name: 'citizen_id',
    label: 'Số CCCD',
    placeholder: 'Số CCCD',
    required: true,
    max_length: 12,
    pattern: '^\\d{9,12}$',
    pattern_message: 'Số CCCD phải gồm 9–12 chữ số',
  },
  radio: {
    type: 'radio',
    name: 'grade',
    label: 'Lớp học',
    required: true,
    options: [
      { value: '11', label: 'Lớp 11' },
      { value: '12', label: 'Lớp 12' },
    ],
  },
  exam_date: {
    type: 'exam_date',
    name: 'exam_date',
    label: 'Ngày thi trải nghiệm',
    required: true,
  },
  school: {
    type: 'school',
    name: 'school',
    label: 'Trường THPT',
    required: true,
    labels: {
      province: 'Tỉnh/TP',
      ward: 'Phường/Xã',
      school: 'Trường THPT',
    },
    placeholders: {
      school: 'Tên trường THPT',
    },
  },
};

export function normalizeFormField(field) {
  const preset = FIELD_TYPE_PRESETS[field.type] || FIELD_TYPE_PRESETS.text;
  const merged = {
    ...preset,
    ...field,
    type: field.type || preset.type,
    name: (field.name || preset.name || '').trim(),
    label: field.label ?? preset.label,
    required: field.required !== false,
  };

  if (merged.type === 'school') {
    merged.labels = { ...preset.labels, ...(field.labels || {}) };
    merged.placeholders = { ...preset.placeholders, ...(field.placeholders || {}) };
  }
  if (merged.type === 'radio') {
    merged.options = field.options?.length ? field.options : preset.options || [];
  }
  if (merged.type === 'email' && merged.name === 'account_email') {
    merged.readonly_when_logged_in = true;
  }

  return merged;
}

export function normalizeFormFields(fields = []) {
  const used = new Set();
  const result = [];
  fields.forEach((raw) => {
    const field = normalizeFormField(raw);
    if (!field.name || used.has(field.name)) {
      return;
    }
    if (field.type === 'school') {
      field.name = 'school';
    }
    used.add(field.name);
    result.push(field);
  });
  return result;
}
